const indexItems = [
  { title: '明星八卦专区', count: '1,286篇', desc: '最新明星动态与恋情爆料' },
  { title: '综艺节目热榜', count: '964篇', desc: '热门综艺话题与幕后花絮' },
  { title: '网红追踪频道', count: '847篇', desc: '头部网红动态与行业观察' },
  { title: '影视资讯速递', count: '732篇', desc: '新片定档与影视市场分析' },
  { title: '时尚穿搭指南', count: '621篇', desc: '明星红毯造型与穿搭解析' },
  { title: '音乐动态速览', count: '518篇', desc: '新歌发布与音乐人专访' },
  { title: '直播带货观察', count: '475篇', desc: '带货行业动态与案例解读' },
  { title: '选秀节目专题', count: '412篇', desc: '选秀节目全程跟踪报道' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-bookmark-line text-sm"></i>
            主题索引
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            主题索引
          </h2>
          <p className="text-foreground-500 text-sm mt-2">按主题快速浏览你感兴趣的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#topics"
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </div>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-3 flex-1">
                {item.desc}
              </p>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <i className="ri-file-text-line"></i>
                <span>{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}